module.exports = __webpack_public_path__ + "static/1-529bb9e8585790379f3415a7dbe6fb15.jpg";